import { SEARCH_FOLDER_TYPE_NAME } from "owa-folders-constants";
import { default as folderStore } from "owa-folders";

export function isSearchFolderForFolderId(folderId: string): boolean {
    const folder = folderStore().folderTable.get(folderId);
    
    return folder?.type === SEARCH_FOLDER_TYPE_NAME;
}
